var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.97412 92.042H92.0575",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 74.4163C17.625 73.897 17.4187 73.3988 17.0514 73.0316C16.6842 72.6643 16.186 72.458 15.6667 72.458H7.83333C7.31395 72.458 6.81584 72.6643 6.44858 73.0316C6.08132 73.3988 5.875 73.897 5.875 74.4163V92.0413H17.625V74.4163Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.125 54.8333C41.125 54.314 40.9187 53.8158 40.5514 53.4486C40.1842 53.0813 39.686 52.875 39.1667 52.875H31.3333C30.814 52.875 30.3158 53.0813 29.9486 53.4486C29.5813 53.8158 29.375 54.314 29.375 54.8333V92.0417H41.125V54.8333Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.625 62.6663C64.625 62.147 64.4187 61.6488 64.0514 61.2816C63.6842 60.9143 63.186 60.708 62.6667 60.708H54.8333C54.314 60.708 53.8158 60.9143 53.4486 61.2816C53.0813 61.6488 52.875 62.147 52.875 62.6663V92.0413H64.625V62.6663Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.125 35.2503C88.125 34.7309 87.9187 34.2328 87.5514 33.8656C87.1842 33.4983 86.686 33.292 86.1667 33.292H78.3333C77.814 33.292 77.3158 33.4983 76.9486 33.8656C76.5813 34.2328 76.375 34.7309 76.375 35.2503V92.042H88.125V35.2503Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7656 50.917C15.0103 50.917 17.6406 48.2867 17.6406 45.042C17.6406 41.7973 15.0103 39.167 11.7656 39.167C8.52095 39.167 5.89062 41.7973 5.89062 45.042C5.89062 48.2867 8.52095 50.917 11.7656 50.917Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2656 31.333C38.5103 31.333 41.1406 28.7027 41.1406 25.458C41.1406 22.2133 38.5103 19.583 35.2656 19.583C32.021 19.583 29.3906 22.2133 29.3906 25.458C29.3906 28.7027 32.021 31.333 35.2656 31.333Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7656 39.167C62.0103 39.167 64.6406 36.5367 64.6406 33.292C64.6406 30.0473 62.0103 27.417 58.7656 27.417C55.521 27.417 52.8906 30.0473 52.8906 33.292C52.8906 36.5367 55.521 39.167 58.7656 39.167Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2656 13.708C85.5103 13.708 88.1406 11.0777 88.1406 7.83301C88.1406 4.58833 85.5103 1.95801 82.2656 1.95801C79.021 1.95801 76.3906 4.58833 76.3906 7.83301C76.3906 11.0777 79.021 13.708 82.2656 13.708Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7046 40.9296L30.7537 29.2188",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8391 27.3145L53.1923 31.4309",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5658 11.3584L62.843 28.533",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesDevelopment);
export default __webpack_public_path__ + "static/media/sales_development.5dc2253f78e790920ca1d0df3b76ac97.svg";
export { ForwardRef as ReactComponent };